/**
 * Open Modal javascript trigger
 */
function openModal(modal, opener){
  if(modal && typeof modal.show === 'function') {
    try {
      modal.show(opener);
    } catch (err) {
      console.error('Modal open error:', err);
    }
  }
}

/**
* background Overlay
*/
class SiteOverlay extends HTMLElement{
  constructor() {
    super();
    this.overlayElement = Utility.DomSelector.byId('site-overlay');
    this.bindEvents();
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   */
  onClick(){
    SiteOverlay.hideOverlay();
  }

  /**
   * Show Overlay
   * @param {string} drawerClass - Optional class to add based on drawer type
   * @returns {boolean} Returns true if overlay was shown, false if already visible
   */
   static showOverlay(drawerClass = null){
    const overlay = Utility.DomSelector.byId('site-overlay');
    if (overlay.classList.contains('overlay--body')) {
      return false; // Already visible
    }
    Utility.CSS.add(overlay, 'overlay--body');
    overlay.setAttribute('aria-hidden', 'true');
    Utility.CSS.add(document.body, 'scroll-fixed');
    // Add drawer-specific class if provided
    if (drawerClass) {
      Utility.CSS.add(overlay, drawerClass);
    }
    // Make background content inert (prevents focus and interaction)
    // const mainContent = Utility.DomSelector.$('main');
    // const header = Utility.DomSelector.$('header');
    // if (mainContent) mainContent.setAttribute('inert', '');
    // if (header) header.setAttribute('inert', '');
    return true; // Successfully shown
  }

  /**
   * Hide overlay
   * @returns {boolean} Returns true if overlay was hidden, false if already hidden
   */
  static hideOverlay(){
    const overlay = Utility.DomSelector.byId('site-overlay');
    if (!overlay.classList.contains('overlay--body')) {
      return false; // Already hidden
    }
    const openDrawers = Utility.DomSelector.$$('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
    // Remove all drawer-specific overlay classes (keep only overlay--body and scroll-fixed)
    const overlayClasses = Array.from(overlay.classList).filter(cls => cls !== 'overlay--body' && cls !== 'scroll-fixed');
    overlayClasses.forEach(cls => Utility.CSS.remove(overlay, cls));
    Utility.CSS.remove(overlay, 'overlay--body');
    Utility.CSS.remove(document.body, 'scroll-fixed');
    // Remove inert from background content
    // const mainContent = Utility.DomSelector.$('main');
    // const header = Utility.DomSelector.$('header');
    // if (mainContent) mainContent.removeAttribute('inert');
    // if (header) header.removeAttribute('inert');
    return true; // Successfully hidden
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick.bind(this));
    this.removeEventListener('touchend', this.onClick.bind(this));
  }
}
if (!customElements.get('site-overlay')) {
  customElements.define("site-overlay", SiteOverlay);
}

/**
* Custom Video
*/
class CustomVideo extends HTMLElement {
  constructor() {
    super();

    this.type = this.dataset.videoType;
    this.videoURL = this.dataset.videoId;
    this.placementType = this.dataset.placement;
    this.videoStatus = 'empty';
    
    this.container = this.closest('.custom-video-container');
    this.videoModal = document.getElementById('PopupModal-video');
    this.contentSection = Utility.DomSelector.$('.content-section', this);
    this.videoSection = Utility.DomSelector.$('.video-section', this);
    if(this.placementType == 'popup') this.videoSection = Utility.DomSelector.$('.video-container', this.videoModal);
    this.triggerVideo = Utility.DomSelector.$('[data-trigger-video]', this) || Utility.DomSelector.$('[data-trigger-video]', this.container);

    this.boundToggleView = this.toggleView.bind(this);
  }

  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    if (this.triggerVideo && this.boundToggleView) {
      this.triggerVideo.removeEventListener('click', this.boundToggleView);
    }

    if (this.soundButton && this.boundToggleSound) {
      this.soundButton.removeEventListener('click', this.boundToggleSound);
    }
  }

  /**
   * Binding events on the video button
   */
  bindEvents(){
    if(Utility.DomSelector.exists('[data-poster-video]', this)) this.managePosterVideos();
    if(this.triggerVideo) this.triggerVideo.addEventListener('click', this.boundToggleView);

    if (this.dataset.muteButton === 'true') {
      this.soundButton = Utility.DomSelector.$('.custom-video-sound-button', this);
      if (this.soundButton) {
        this.boundToggleSound = this.toggleSound.bind(this);
        this.soundButton.addEventListener('click', this.boundToggleSound);
        this.soundButton.addEventListener('pointerdown', (event) => event.stopPropagation());
        this.soundButton.addEventListener('touchstart', (event) => event.stopPropagation(), { passive: true });
      }
    }

    // Autoplay on init if placement is grid and autoplay is true and not in a swiper slide. Slider autoplay is managed by the manageSwiperSlides function to support slide init with deferred js loading.
    if(this.dataset.placement == 'grid' && this.dataset.autoplay == 'true' && !this.closest('swiper-slide')) this.autoplayOnInit();
  }

  /**
   * Returns the active video or iframe element inside the player.
   * @returns {HTMLVideoElement|HTMLIFrameElement|null}
   */
  _getVideoElement() {
    return Utility.DomSelector.$('.video-section video', this)
      || Utility.DomSelector.$('.video-section iframe', this);
  }

  /**
   * Returns the poster preview video when poster_type is video.
   * @returns {HTMLVideoElement|null}
   */
  _getPosterVideoElement() {
    return Utility.DomSelector.$('[data-poster-video]', this);
  }

  /**
   * Pause and reset the poster preview video.
   */
  _pausePosterVideo() {
    const posterVideo = this._getPosterVideoElement();
    if (!posterVideo) return;

    posterVideo.pause();
    posterVideo.muted = true;
    posterVideo.currentTime = 0;
  }

  /**
   * Mute or unmute the playing video (local file or YouTube iframe).
   * @param {HTMLVideoElement|HTMLIFrameElement} video
   * @param {boolean} muted
   */
  _setVideoMuted(video, muted) {
    if (!video) return;

    try {
      if (this.type === 'local') {
        video.muted = muted;
        video.volume = muted ? 0 : 1;
        if (!muted && video.paused) {
          video.play().catch((err) => console.warn('Video play blocked:', err));
        }
      } else if (this.type === 'youtube') {
        const func = muted ? 'mute' : 'unMute';
        video.contentWindow?.postMessage(
          JSON.stringify({ event: 'command', func, args: '' }),
          '*'
        );
      }
    } catch (err) {
      console.error('Set video mute error:', err);
    }
  }

  /**
   * Applies sound on/off to the video and toggles sound-on on the custom-video parent.
   * @param {HTMLVideoElement|HTMLIFrameElement} videoElement
   * @param {boolean} enableSound
   */
  _applySoundState(videoElement, enableSound) {
    this._setVideoMuted(videoElement, !enableSound);
    this.classList.toggle('sound-on', enableSound);

    if (this.soundButton) {
      this.soundButton.setAttribute(
        'aria-label',
        enableSound
          ? (globalThis.customVideoStrings?.mute ?? 'Mute video')
          : (globalThis.customVideoStrings?.unmute ?? 'Unmute video')
      );
      this.soundButton.setAttribute('aria-pressed', enableSound ? 'true' : 'false');
    }
  }

  /**
   * Force mute and reset UI (used on slider swipe; unmute is only via the sound button).
   */
  muteSound() {
    this.classList.remove('sound-on');

    const videoElement = this._getVideoElement();
    if (videoElement) {
      this._setVideoMuted(videoElement, true);
    }

    const posterVideo = this._getPosterVideoElement();
    if (posterVideo) {
      posterVideo.muted = true;
    }

    if (this.soundButton) {
      this.soundButton.setAttribute('aria-pressed', 'false');
      this.soundButton.setAttribute(
        'aria-label',
        globalThis.customVideoStrings?.unmute ?? 'Unmute video'
      );
    }
  }

  /**
   * Toggle video sound via the sound button only; adds sound-on to the custom-video parent.
   * @param {Event} event
   */
  toggleSound(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const enableSound = !this.classList.contains('sound-on');
    const isMainVideoPlaying = this.container?.classList.contains('playing--video');
    let videoElement = isMainVideoPlaying ? this._getVideoElement() : null;

    if (videoElement) {
      this._applySoundState(videoElement, enableSound);
      return;
    }

    const posterVideo = this._getPosterVideoElement();
    if (posterVideo) {
      this._applySoundState(posterVideo, enableSound);
      return;
    }

    if (this.videoStatus === 'empty') {
      this.showContent();
    }

    setTimeout(() => {
      videoElement = this._getVideoElement();
      if (videoElement) {
        this._applySoundState(videoElement, enableSound);
      }
    }, 550);
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(_event){
    if(this.container.classList.contains('playing--video')) this.toggleView();
  }

  /**
   * Toggle of video modal
   * @returns {CustomVideo} Returns this for method chaining
   */
  toggleView(event){
    if(event) event.preventDefault();
    const isOpen = this.container.classList.contains('playing--video');
    if (isOpen) {
      this.hideContent();
    } else {
      this.showContent();
    }
    return this; // Enable method chaining
  }

  /**
   * Show panel content
   * @returns {CustomVideo} Returns this for method chaining
   */
  showContent() {
    if (this.videoStatus === 'empty' || this.placementType === 'popup') {
      const videoElement = this._buildVideo();
      if (!videoElement) {
        console.error('Failed to build video element');
        return this;
      }
      
      videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);
      
      if (!this.videoSection) {
        console.error('Video section not found');
        return this;
      }
      
      this.videoSection.appendChild(videoElement);
      this.videoStatus = 'loaded';

      setTimeout(() => {
        (this.placementType === 'popup') ? openModal(this.videoModal, this.triggerVideo) : Utility.CSS.add(this.container, 'playing--video');
        this.videoSection.removeAttribute('inert');
        this.videoSection.setAttribute('aria-hidden', 'false');
        if(this.dataset.controls === 'true') this.pauseOnVisibilityChange(videoElement);
      }, 500);
    } else {
      const videoElement = Utility.DomSelector.$('.video-section video', this) || Utility.DomSelector.$('.video-section iframe', this);
      if (videoElement) {
        Utility.CSS.add(this.container, 'playing--video');
        this._playVideo(videoElement);
      }
    }
    return this; // Enable method chaining
  }

  /**
   * Hide panel content
   * @returns {CustomVideo} Returns this for method chaining
   */
  hideContent() {
    Utility.CSS.remove(this.container, 'playing--video');
    this.classList.remove('sound-on');
    this.videoSection.setAttribute('inert', '');
    this.videoSection.setAttribute('aria-hidden', 'true');
    const videoElement = this._getVideoElement();
    if (videoElement) {
      this._pauseVideo(videoElement);
    }
    this._pausePosterVideo();
    if (this.soundButton) {
      this.soundButton.setAttribute('aria-pressed', 'false');
      this.soundButton.setAttribute(
        'aria-label',
        globalThis.customVideoStrings?.unmute ?? 'Unmute video'
      );
    }
    return this; // Enable method chaining
  }

  _playVideo(video){
    if (!video) return;

    try {
      if(this.type === 'local'){
        video.play().catch(err => console.warn('Video autoplay blocked:', err));
      } else if(this.type === 'youtube'){
        video.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', 'https://www.youtube.com');
      }
    } catch (err) {
      console.error('Play video error:', err);
    }
  }

  _pauseVideo(video) {
    if (!video) return;
    
    try {
      if (this.type === 'local') {
        video.pause();
      } else if (this.type === 'youtube') {
        video.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', 'https://www.youtube.com');
      }
    } catch (err) {
      console.error('Pause video error:', err);
    }
  }

  /**
   * Create the video html element
   */
  _buildVideo(){
    try {
      if (!this.videoURL) {
        console.error('Video URL is missing');
        return null;
      }

      const hasControls = this.dataset.controls === 'true';
      const isMuted = !this.classList.contains('sound-on') && this.dataset.muted === 'true';
      const isLoop = this.dataset.loop === 'true';

      if(this.type === 'local'){
        const video = document.createElement('video');
        video.src = this.videoURL;
        video.autoplay = true;
        video.playsInline = true;
        if(hasControls) video.controls = true;
        if(isMuted) video.muted = true;
        if(isLoop) video.loop = true;
        return video;
      }

      if(this.type === 'youtube'){
        const videoID = this.videoURL.replace('https://www.youtube.com/watch?v=', '');
        if (!videoID) {
          console.error('Invalid YouTube URL');
          return null;
        }
        const video = document.createElement("iframe");
        video.setAttribute("allowfullscreen", "");
        video.setAttribute("frameborder", "0");
        video.setAttribute("allow", "autoplay");
        video.setAttribute("src", `https://www.youtube.com/embed/${videoID}?rel=0&showinfo=0&autoplay=1&mute=${isMuted ? 1 : 0}&controls=${hasControls ? 1 : 0}&loop=${isLoop ? 1 : 0}&enablejsapi=1&origin=${window.origin}`);
        return video;
      }

      return null;
    } catch (err) {
      console.error('Video build error:', err);
      return null;
    }
  }

  /**
   * Pause video on scroll when out of viewport
   */
  pauseOnVisibilityChange(videoEle){
    if (!videoEle) return;
    
    this.scrollObserver = Utility.Observer.onChange(
      videoEle,
      null,  // onEnter - no action needed
      (video) => {  // onExit - pause video
        if(!video || video.contentWindow == null){
          this.scrollObserver?.disconnect();
          return;
        }
        this._pauseVideo(video);
      }
    );
  }

  /**
   * Poster Video Autoplay
   */
  managePosterVideos(){
    const posterVideo = Utility.DomSelector.$('[data-poster-video]', this);
    if(!posterVideo) return;

    Utility.Observer.once(posterVideo, (video) => {
      try {
        if (!video.dataset.src) return;
        const sourceTag = document.createElement('source');
        sourceTag.src = video.dataset.src;
        sourceTag.type = "video/mp4";
        video.appendChild(sourceTag);
        video.play().catch(err => console.warn('Poster video autoplay blocked:', err));
      } catch (err) {
        console.error('Poster video error:', err);
      }
    });
  }

  autoplayOnInit(element = this){
    Utility.Observer.once(element, (el, entry) => {
      if(entry.intersectionRatio > 0){
        el.toggleView();
      }
    });
  }
}
customElements.define("custom-video", CustomVideo);

/**
* Modal Dialogue
*
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;
    this.modal = Utility.DomSelector.$('.modal', this);
    this.modalOpeners = Utility.DomSelector.$$(`[data-modal-opener="${this.id}"]`);
    this.closeBtn = Utility.DomSelector.$('[id^="ModalClose-"]', this);

    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');
  }

  connectedCallback() {
    this.modalOpeners.forEach((opener)=>{
      opener.addEventListener('click', (evt)=>{
        evt.preventDefault();
        this.show(opener);
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.hide.bind(this));
    }

    this.addEventListener('click', (evt) => {
      if (evt.target === this) this.hide();
    });
  }

  // Clean up event listeners
  disconnectedCallback() {
    this.isOpen = false;

    this.modalOpeners.forEach((opener) => {
      opener.removeEventListener('click', this.show.bind(this));
    });

    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }

    this.removeEventListener('click', this.hide);
  }

  /**
   * Open the Modal
   * @param {element} opener 
   * @returns {ModalDialog} Returns this for method chaining
   */
  show(opener) {
    if (this.isOpen) return this; // Prevent opening if already open

    this.isOpen = true;
    this.openedBy = opener;
    Utility.CSS.add(this.modal, 'open');
    this.removeAttribute('inert');
    this.setAttribute('aria-hidden', 'false');

    SiteOverlay.showOverlay();
    
    // Announce modal opening with specific name
    const modalName = this.getAttribute('aria-label') || 'Modal Dialogue';
    Utility.announceToScreenReader(`${modalName} modal opened`);
    
    Utility.Focus.trap(this, this.closeBtn); // falls back to first focusable element if no close button

    return this; // Enable method chaining
  }

  /**
   * Close Modal Dialogue
   * @returns {ModalDialog} Returns this for method chaining
   */
  hide() {
    if (!this.isOpen) return this; // Prevent closing if already closed

    this.isOpen = false;
    Utility.CSS.remove(this.modal, 'open');
    this.setAttribute('inert', '');
    this.setAttribute('aria-hidden', 'true');

    SiteOverlay.hideOverlay();
    
    // Announce modal closing with specific name
    const modalName = this.getAttribute('aria-label') || 'Modal Dialogue';
    Utility.announceToScreenReader(`${modalName} modal closed`);
    
    Utility.Focus.release(this.openedBy);
    if(this.id == 'PopupModal-video') {
      Utility.DomSelector.$('.video-container', this).innerHTML = '';
    }
    
    return this; // Enable method chaining
  }
}
customElements.define('modal-dialog', ModalDialog);

class CustomDrawer extends HTMLElement {
  constructor() {
      super();
      this.isOpen = false;

      this.openedBy = null;
      this.toggleDrawer = Utility.DomSelector.$$(`[data-toggleDrawer="${this.id}"], a[href="#${this.id}"]`);
      this.closeButtons = Utility.DomSelector.$$('[data-closedrawer]', this);
      const focusSelector = this.dataset.focusSelector;
      this.forceFocus = focusSelector
        ? Utility.DomSelector.$(focusSelector, this)
        : Utility.DomSelector.$('[data-closedrawer]', this);
      this.setAttribute('aria-hidden', 'true');
      this.setAttribute('inert', '');
  }

  connectedCallback() {
    this.bindEvents()
  }

  disconnectedCallback() {
    this.toggleDrawer.forEach(btn => btn.removeEventListener('click', this.openDrawer()));

    this.closeButtons.forEach(btn => btn.removeEventListener('click', this.closeDrawer.bind(this)));
    this.removeEventListener('focusout', this.focusOut.bind(this));
  }

  bindEvents(){
    this.toggleDrawer.forEach(btn => {
      btn.setAttribute('aria-expanded', false);
      btn.addEventListener('click', (evt) => {
        evt.preventDefault();
        (this.isOpen) ? this.closeDrawer(evt) : this.openDrawer(evt.currentTarget);
      });
    });

    this.closeButtons.forEach(btn => btn.addEventListener('click', this.closeDrawer.bind(this)));
    this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Focus Out Event to close drawer
   */
  focusOut(evt){
    if (!this.contains(evt.relatedTarget) && this.open) {
      this.closeDrawer();
    }
  }

  openDrawer(opener) {
    // Prevent opening if already open
    if (this.isOpen) return this;

    this.resetOtherDrawers();

    this.isOpen = true;
    this.openedBy = opener || null;
    Utility.CSS.add(this, 'open');
    this.removeAttribute('inert');
    this.setAttribute('aria-hidden', 'false');

    // Create drawer-specific overlay class from drawer ID
    const drawerClass = this.id || null;
    SiteOverlay.showOverlay(drawerClass);
    
    // Add below-header class to overlay if drawer has it
    const overlay = Utility.DomSelector.byId('site-overlay');
    if (overlay && this.classList.contains('below-header')) {
      Utility.CSS.add(overlay, 'below-header');
    }
    
    this.openedBy?.setAttribute('aria-expanded', true);
    Utility.Focus.trap(this, this.forceFocus); // falls back to first focusable element if no close button

    // Announce drawer opening to screen readers
    const drawerName = this.getAttribute('aria-label') || 'Drawer';
    Utility.announceToScreenReader(`${drawerName} drawer opened`);
    
    return this; // Enable method chaining
  }

  closeDrawer() {
      if (!this.isOpen) return this;

      Utility.CSS.remove(this, 'open');
      
      // Remove drawer-specific overlay class and below-header class
      const overlay = Utility.DomSelector.byId('site-overlay');
      if (overlay && this.id) {
        Utility.CSS.remove(overlay, this.id);
        Utility.CSS.remove(overlay, 'below-header');
      }
      
      SiteOverlay.hideOverlay();

      this.isOpen = false;
      this.setAttribute('inert', '');
      this.setAttribute('aria-hidden', 'true');
      this.hideOpenPanels();
      this.openedBy?.setAttribute('aria-expanded', false);
      Utility.Focus.release(this.openedBy);
      
      // Announce drawer closing to screen readers
      const drawerName = this.getAttribute('aria-label') || 'Drawer';
      Utility.announceToScreenReader(`${drawerName} drawer closed`);
      
      if(this.id == 'quickshop-drawer') {
        Utility.DomSelector.$('[data-quickshop-body]', this).innerHTML = '';
      }else if(this.id == 'header-search-layer') {
        const searchInput = this.querySelector('input[name="q"]');
        if(searchInput) {
          searchInput.value = '';
          searchInput.dispatchEvent(new Event('input'));
        }
      }
      this.openedBy = null;
      
      return this; // Enable method chaining
  }

  resetOtherDrawers(){
    const openDrawers = Utility.DomSelector.$$('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
    return this; // Enable method chaining
  }

  hideOpenPanels(){
    let openPanels = this.querySelectorAll('[is="collapsiblePanel"].open');
    openPanels.forEach(panel => panel.querySelector('[data-toggle="panel"]').click());

    let openDropdowns = Array.from(this.querySelectorAll('[is="drop-down"].open'));
    openDropdowns.forEach((ele) => {
      Utility.CSS.remove(ele, 'open');
      Utility.DomSelector.$('[data-toggle="open"]', ele)?.setAttribute('aria-expanded', false);
    });
    return this; // Enable method chaining
  }
}
customElements.define('custom-drawer', CustomDrawer);

// Single global Escape handler for all drawers, modals and dropdowns
document.addEventListener('keyup', (evt) => {
  if (!evt.code || evt.code.toUpperCase() !== 'ESCAPE') return;
  Utility.DomSelector.$$('custom-drawer.open').forEach(drawer => drawer.closeDrawer());
  Utility.DomSelector.$$('modal-dialog[aria-hidden="false"]').forEach(modal => modal.hide());
  Utility.DomSelector.$$('custom-select.open').forEach(select => select.closeDropdown());
});

/**
   * Manage Custom Notification Trigger
   *
   */
class ToastNotification extends HTMLElement {
  constructor() {
    super();

    this.container = Utility.DomSelector.$('.snotifyToast', this);
    this.closeBtn = Utility.DomSelector.$('.snotifyToast__close', this);
    this.animateNotifcation = null;

    // Set ARIA role for accessibility
    this.container.setAttribute('role', 'alert');
    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');
  }

  connectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.hide();
      });
    }
  }

  disconnectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }
  }

  /**
   * Notification Type
   * @param {string} title 
   * @param {string} body 
   * @param {object} options 
   * @returns {ToastNotification} Returns this for method chaining
   */
  updateNotification(title, body, options){
    this.setAttribute('aria-hidden', 'false');
    this.removeAttribute('inert');

    Utility.CSS.add(this.container, 'open', `snotify-${options.type}`);
    Utility.DomSelector.$('.snotifyToast__title', this).textContent = title;
    Utility.DomSelector.$('.snotifyToast__body', this).textContent = body;

    this._manageToggle(options.timeout);
    
    return this; // Enable method chaining
  }

  /**
   * Duration of notification to hide again
   * @param timeout 
   */
  _manageToggle(timeout) {
    this.progressBar = Utility.DomSelector.$('[data-toast-pr]', this);
    const totalFrames = Math.ceil(timeout / 16.67) / 2;
    let frame =0; 
    let width = 0;

    this.animateNotifcation = () => {
      width = (frame / totalFrames) * 100;
      this.progressBar.setAttribute('style', `width: ${width}%`);
      if (frame < totalFrames) {
        frame++;
        requestAnimationFrame(this.animateNotifcation);
      } else {
        this.closeBtn.dispatchEvent(new Event('click'));
      }
    };
    requestAnimationFrame(this.animateNotifcation);
  }

  /**
   * Hide notification
   * @returns {ToastNotification} Returns this for method chaining
   */
  hide() {
    if (this.animateNotification) {
      cancelAnimationFrame(this.animateNotification);
    }
    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');

    this.container.className = 'snotifyToast';
    [Utility.DomSelector.$('.snotifyToast__title', this),Utility.DomSelector.$('.snotifyToast__body', this)].forEach(ele => ele.textContent = '');
    Utility.DomSelector.$("[data-toast-pr]", this).removeAttribute("style");

    return this; // Enable method chaining
  }
}
customElements.define("toast-notification", ToastNotification);
window.notificationEle = Utility.DomSelector.$('toast-notification');

//===============================================================================================================
//          Video Management Functions for Custom Video in Swiper Slides                                        //
//===============================================================================================================

const SWIPE_INTERACTION_IGNORE = 'button, a, input, textarea, select, [data-toggle-text], .custom-video-sound-button';
const SWIPE_PAUSE_THRESHOLD_PX = 3;
const VIDEO_SWIPE_TARGET = 'custom-video, .custom-video-container';

/**
 * @param {HTMLElement} swiperEl
 * @returns {HTMLElement|null}
 */
const getActiveSwiperSlide = (swiperEl) => {
  const swiperInstance = swiperEl?.swiper;
  return swiperInstance?.slides?.[swiperInstance.activeIndex]
    || Utility.DomSelector.$('swiper-slide.swiper-slide-active', swiperEl)
    || Utility.DomSelector.$('swiper-slide', swiperEl);
};

/**
 * @param {EventTarget|null} target
 * @returns {boolean}
 */
const isSwipeOutsideVideo = (target) => (
  target instanceof Element && !target.closest(VIDEO_SWIPE_TARGET)
);

/**
 * Mute slide video without pausing playback (unmute only via sound button).
 * @param {HTMLElement} slide
 */
const muteSlideVideo = (slide) => {
  if (!slide) return;

  const videoHost = Utility.DomSelector.$('custom-video', slide);
  if (videoHost?.muteSound) {
    videoHost.muteSound();
    return;
  }

  slide.querySelectorAll('video').forEach((video) => {
    video.muted = true;
  });
};

/**
 * Mute videos in swiper slides without pausing.
 * @param {HTMLElement} swiperEl
 * @param {{ muteOnlyIfOutsideVideo?: boolean, eventTarget?: EventTarget|null }} [options]
 */
const muteSwiperVideos = (swiperEl, options = {}) => {
  if (!swiperEl) return;

  const { muteOnlyIfOutsideVideo = false, eventTarget = null } = options;
  const shouldMute = muteOnlyIfOutsideVideo
    ? isSwipeOutsideVideo(eventTarget)
    : true;

  if (!shouldMute) return;

  swiperEl.querySelectorAll('swiper-slide').forEach((slide) => muteSlideVideo(slide));
};

/**
 * Keep slide video playing; only adjust mute state (never pause on swipe).
 * Popup videos open only via the play button — not on slide change.
 * @param {HTMLElement} slide
 */
const ensureSlideVideoPlaying = (slide) => {
  if (!slide) return;

  const videoHost = Utility.DomSelector.$('custom-video', slide);
  if (!videoHost || videoHost.dataset.placement === 'popup') return;

  try {
    if (videoHost.videoStatus === 'empty') {
      if (videoHost.dataset.autoplay === 'true') {
        videoHost.showContent();
      }
      return;
    }

    const media = videoHost._getVideoElement();
    if (!media) return;

    Utility.CSS.add(videoHost.container, 'playing--video');
    videoHost._setVideoMuted(media, !videoHost.classList.contains('sound-on'));

    if (media.paused) {
      videoHost._playVideo(media);
    }
  } catch (err) {
    console.error('Swiper slide video play error:', err);
  }
};

/**
 * Run autoplay on first active slide if autoplay is true and placement is grid
 * @param {HTMLElement} swiperEl
 */
const runAutoplayIfActive = (swiperEl) => {
  const slide = getActiveSwiperSlide(swiperEl);
  const videoHost = slide && Utility.DomSelector.$('custom-video', slide);
  if (!videoHost || videoHost.dataset.placement !== 'grid' || videoHost.dataset.autoplay !== 'true') return;
  ensureSlideVideoPlaying(slide);
};

/**
 * @param {EventTarget|null} target
 * @returns {boolean}
 */
const shouldIgnoreSwiperVideoInteraction = (target) => (
  target instanceof Element && !!target.closest(SWIPE_INTERACTION_IGNORE)
);

/**
 * Bind swipe and slide-change handlers — mute only, never pause on scroll.
 * @param {HTMLElement} swiperEl
 */
const bindSwiperVideoControls = (swiperEl) => {
  if (!swiperEl || swiperEl.dataset.videoControlsBound === 'true') return;
  if (!swiperEl.querySelector('custom-video')) return;

  swiperEl.dataset.videoControlsBound = 'true';

  const swipeState = { startX: 0, startY: 0, startTarget: null };

  const muteOnSwipe = (eventTarget) => {
    muteSwiperVideos(swiperEl, { muteOnlyIfOutsideVideo: true, eventTarget });
  };

  const onTouchStart = (event) => {
    if (shouldIgnoreSwiperVideoInteraction(event.target)) return;
    const touch = event.touches?.[0];
    swipeState.startX = touch?.clientX ?? 0;
    swipeState.startY = touch?.clientY ?? 0;
    swipeState.startTarget = event.target;
  };

  const onTouchMove = (event) => {
    if (shouldIgnoreSwiperVideoInteraction(event.target)) return;
    const touch = event.touches?.[0];
    if (!touch) return;

    const deltaX = Math.abs(touch.clientX - swipeState.startX);
    const deltaY = Math.abs(touch.clientY - swipeState.startY);
    if (deltaX > SWIPE_PAUSE_THRESHOLD_PX || deltaY > SWIPE_PAUSE_THRESHOLD_PX) {
      muteOnSwipe(swipeState.startTarget);
    }
  };

  const onSlideChange = ({ detail }) => {
    const swiperInstance = detail?.[0];
    if (!swiperInstance?.slides || swiperInstance.activeIndex == null) return;

    swiperInstance.slides.forEach((slide) => muteSlideVideo(slide));
    ensureSlideVideoPlaying(swiperInstance.slides[swiperInstance.activeIndex]);
  };

  const bindSwiperInstanceEvents = () => {
    const swiper = swiperEl.swiper;
    if (!swiper || swiper.__artzaVideoBound) return;

    swiper.__artzaVideoBound = true;
    const muteFromSwiper = () => muteOnSwipe(swipeState.startTarget);
    swiper.on('touchStart', muteFromSwiper);
    swiper.on('sliderMove', muteFromSwiper);
  };

  swiperEl.addEventListener('touchstart', onTouchStart, { passive: true });
  swiperEl.addEventListener('touchmove', onTouchMove, { passive: true });
  swiperEl.addEventListener('swiperslidechange', onSlideChange);
  swiperEl.addEventListener('swiper:init', () => {
    runAutoplayIfActive(swiperEl);
    bindSwiperInstanceEvents();
  }, { once: true });

  if (swiperEl.swiper) {
    bindSwiperInstanceEvents();
  }
};

/**
 * Manage Swiper slide video control
 */
const manageSwiperSlides = () => {
  Utility.DomSelector.$$('swiper-container').forEach(bindSwiperVideoControls);
};
manageSwiperSlides();

document.addEventListener('shopify:section:load', manageSwiperSlides);

customElements.whenDefined('swiper-container')
  .then(manageSwiperSlides)
  .catch((error) => {
    console.error('Swiper failed to load:', error);
  });

//===============================================================================================================
//          End of Video Management Functions for Custom Video and Swiper Slide Components                      //
//===============================================================================================================


//===============================================================================================================
//          Update Product Media Height Functions for Product Cards                                        //
//===============================================================================================================

(() => {
  const NAV_SELECTOR = '.custom-swiper-navigation';
  const TAB_TOGGLE_SELECTOR = '[data-toggle="tab"]';
  const TAB_PANEL_SELECTOR = '[data-tabpanel]';
  const TAB_CONTENT_CLASS = 'tabcontent';
  const DELAY = 50;
  const RESIZE_DELAY = 100;

  const updateHeights = () => {
    const cards = document.querySelectorAll('.card-product');
    if (cards.length === 0) return;

    // Batch read phase: collect all data
    // Reading offsetHeight forces layout, so we batch all reads together
    const updates = [];
    for (let i = 0; i < cards.length; i++) {
      const card = cards[i];
      if (!card || card.offsetParent === null) continue;

      const media = card.querySelector('.product--media');
      if (!media) continue;

      // Query nav in read phase (doesn't force layout, but batches DOM queries)
      const nav = card.closest('.swiper-wrapper__custom, section, .slider-wrapper')?.querySelector(NAV_SELECTOR);

      // Store all data for batch write phase
      updates.push({
        card,
        height: media.offsetHeight, // This forces layout - batched with all other reads
        nav
      });
    }

    // Batch write phase: apply all style changes at once
    // This reduces layout thrashing by grouping all writes together
    for (let i = 0; i < updates.length; i++) {
      const { card, height, nav } = updates[i];
      const heightStr = `${height}px`;

      // Apply card style
      card.style.setProperty('--product-media-height', heightStr);

      // Apply nav styles if nav exists
      if (nav) {
        nav.style.setProperty('--product-media-height', heightStr);
        nav.style.setProperty('--nav-opacity', '1');
        nav.classList.add('arrow-center-image');
      }
    }
  };

  const scheduleUpdate = (delay = 0) => window.setTimeout(updateHeights, delay);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeights, { once: true });
  } else {
    updateHeights();
  }

  window.addEventListener('load', updateHeights);

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(updateHeights, RESIZE_DELAY);
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest(TAB_TOGGLE_SELECTOR)) scheduleUpdate(DELAY);
  });

  const observer = new MutationObserver((mutations) => {
    const shouldUpdate = mutations.some(({ target, attributeName }) => (
      ['aria-hidden', 'class'].includes(attributeName) &&
      target.classList?.contains(TAB_CONTENT_CLASS) &&
      target.classList.contains('open') &&
      target.getAttribute('aria-hidden') === 'false'
    ));

    if (shouldUpdate) scheduleUpdate(DELAY);
  });

  document.querySelectorAll(TAB_PANEL_SELECTOR).forEach((panel) => {
    observer.observe(panel, { attributes: true, attributeFilter: ['aria-hidden', 'class'] });
  });
})();

//===============================================================================================================
//          End of Update Product Media Height Functions for Product Cards                                        //
//===============================================================================================================

// Dropdown outside-click handler → moved to dropdown.js

// Restock Alerts modal — dismiss on outside click
(function bindRestockModalDismiss() {
  const MODAL_SELECTOR = '.restock-alerts-modal-wrapper.modalWrapperStyle';
  const MODAL_BOX_SELECTOR = '.modalBoxStyle';
  const NOTIFY_TRIGGER_SELECTOR = '.restock-alerts-notify-button, .product-notify-link, .nm-portal button';

  const closeRestockModal = () => {
    const closeBtn = document.querySelector('.modalCloseButtonWrapper .modal-close-btn');
    if (!closeBtn) return;

    closeBtn.dispatchEvent(new PointerEvent('pointerdown', { bubbles: true }));
    closeBtn.dispatchEvent(new PointerEvent('pointerup', { bubbles: true }));
    closeBtn.dispatchEvent(new MouseEvent('click', { bubbles: true }));
  };

  document.addEventListener('click', (event) => {
    const modal = document.querySelector(MODAL_SELECTOR);
    if (!modal) return;
    if (event.target.closest(NOTIFY_TRIGGER_SELECTOR)) return;

    const modalBox = modal.querySelector(MODAL_BOX_SELECTOR);
    if (modalBox?.contains(event.target)) return;

    closeRestockModal();
  });
})();

//===============================================================================================================
//          Header and Announcement Bar Height Calculator                                                       //
//===============================================================================================================


function setHeaderTopbarCSSVars() {
  const root = document.documentElement;
  const header = document.querySelector('.section-header');
  const topbar = document.querySelector('.topbar');
  
  if (header) {
    const headerHeight = header.offsetHeight;
    root.style.setProperty('--header-height', headerHeight + 'px');
  }
  if (topbar) {
    const topbarHeight = topbar.offsetHeight;
    root.style.setProperty('--announcement-bar-height', topbarHeight + 'px');
  }
}
setHeaderTopbarCSSVars();
window.addEventListener('resize', setHeaderTopbarCSSVars);


//===============================================================================================================
//          End of Header and Announcement Bar Height Calculator                                               //
//===============================================================================================================


//===============================================================================================================
//          Update Swiper Container Height Functions for Slider Components                                        //
//===============================================================================================================
document.querySelectorAll('swiper-container').forEach((swiperEl, i) => {
  let swipercontainer = swiperEl.closest('section');
  
  if(!swipercontainer) return;

   const observer = new MutationObserver(() => {
      try {
      const slides = swipercontainer.querySelectorAll('swiper-slide');
      const firstSlide = slides[0];
      if (!firstSlide) return;
      const firstImg = firstSlide.querySelector('img');
      if (!firstImg) return;
      const target = firstImg.closest(".target-this-height");
      if (target) {
        const height = firstImg.getBoundingClientRect().height;
        target.style.setProperty("--img-height", height + "px");
      }
      } catch (e) {
        globalJsRollbar('swiperHeightMutationObserver', e);
      }
    });

    observer.observe(swipercontainer, {
      childList: true,
      subtree: true,
      attributes: true
    });
});


//===============================================================================================================
//          Background Change on Scroll Functions for Sections                                        //
//===============================================================================================================
const bgMorph = document.getElementById('bg-morph');

if (bgMorph) {
  const sections = Array.from(
    document.querySelectorAll('.shopify-section section[data-color]')
  ).map(el => ({ el, color: el.getAttribute('data-color') }));

  const SCROLL_BLEND = 0.7;
  const COLOR_LERP = 0.08;

  function hexToRgb(h) {
    return [
      parseInt(h.slice(1, 3), 16),
      parseInt(h.slice(3, 5), 16),
      parseInt(h.slice(5, 7), 16)
    ];
  }

  function blendRgb(c1, c2, t) {
    return c1.map((c, i) => Math.round(c + (c2[i] - c) * t));
  }

  function getElementMid(el) {
    const rect = el.getBoundingClientRect();
    return window.scrollY + rect.top + rect.height / 2;
  }

  function buildMidpoints() {
    return sections.map(s => ({
      ...s,
      mid: getElementMid(s.el),
      rgb: hexToRgb(s.color)
    }));
  }

  let pts = buildMidpoints();
  let targetRgb = pts[0]?.rgb || hexToRgb('#F6F4EC');
  let displayRgb = [...targetRgb];
  let scrollScheduled = false;

  function computeTargetRgb() {
    if (!pts.length) pts = buildMidpoints();
    if (!pts.length) return targetRgb;

    const vpCenter = window.scrollY + window.innerHeight * SCROLL_BLEND;

    if (vpCenter <= pts[0].mid) return pts[0].rgb;
    if (vpCenter >= pts[pts.length - 1].mid) return pts[pts.length - 1].rgb;

    for (let i = 0; i < pts.length - 1; i++) {
      const a = pts[i];
      const b = pts[i + 1];
      if (vpCenter >= a.mid && vpCenter <= b.mid) {
        const span = b.mid - a.mid;
        const t = span > 0 ? (vpCenter - a.mid) / span : 0;
        return blendRgb(a.rgb, b.rgb, t);
      }
    }

    return targetRgb;
  }

  function scheduleScrollUpdate() {
    if (scrollScheduled) return;
    scrollScheduled = true;
    requestAnimationFrame(() => {
      scrollScheduled = false;
      targetRgb = computeTargetRgb();
    });
  }

  function tick() {
    displayRgb = displayRgb.map((c, i) => c + (targetRgb[i] - c) * COLOR_LERP);
    bgMorph.style.backgroundColor = `rgb(${displayRgb.map(Math.round).join(',')})`;
    requestAnimationFrame(tick);
  }

  let resizeScheduled = false;

  function scheduleMidpointRebuild() {
    if (resizeScheduled) return;
    resizeScheduled = true;
    requestAnimationFrame(() => {
      resizeScheduled = false;
      pts = buildMidpoints();
      scheduleScrollUpdate();
    });
  }

  window.addEventListener('load', () => {
    pts = buildMidpoints();
    targetRgb = computeTargetRgb();
    displayRgb = [...targetRgb];
  });

  window.addEventListener('scroll', scheduleScrollUpdate, { passive: true });
  window.addEventListener('resize', scheduleMidpointRebuild);
  window.addEventListener('bg-morph:recalculate', scheduleMidpointRebuild);

  if (typeof ResizeObserver !== 'undefined') {
    const sectionResizeObserver = new ResizeObserver(scheduleMidpointRebuild);
    sections.forEach(({ el }) => sectionResizeObserver.observe(el));
  }

  targetRgb = computeTargetRgb();
  displayRgb = [...targetRgb];
  requestAnimationFrame(tick);
}





